const Theme = {
  colors: {
    white: "#FFFFFF",
    blackText: "#333333",
    greyText: "#C3C7C6",
    accentCool: "#4265ad",
    accentCoolLight: "#94A3D0",
    accentWarm: "#FFFFFF",
    accentWarmLight: "#FFFFFF",
    darkBackground: "#5173B8",
    darkMenuBackground: "#4266AD",
    darkBackgroundHover: "#3E5C98",
    darkBackgroundDivider: "#FFFFFF",
    lightBackground: "#E0DEDF",
    lightBackgroundHover: "#C4C4C4",
    warning: "#FF6600",
    error: "#ed6467",
    success: "#408842",
    info: "#6192f8",
    buttonPrimary: "#5A7DBD",
    buttonPrimaryHover: "#3E5C98",
    buttonPrimaryDisabled: "#94A3D0",
    buttonSecondary: "#4db54e",
    buttonSecondaryHover: "#3E903F",
    buttonSecondaryDisabled: "#77A777",
    buttonDanger: "#CA5558",
    buttonDangerHover: "#AC484B",
    buttonDangerDisabled: "#526FA7",
    addAccess: "#64ED64",
    removeAccess: "#ED6464",
    lightTable: "#DDFFFF",
    lightTableAlt: "#CDEFEF",
  },
  fonts: {
    title: "'Header', 'Oxygen', sans-serif",
    body: "'Open Sans', 'Source Sans Pro', sans-serif",
    header: "Arial, sans-serif",
  },
  sizes: {
    title: "36px",
    navHeight: "115px",
    menuDefault: "18px",
  },
};

export default Theme;
